import React from "react";

import Link, { LinkProps } from "next/link";
import clx from "classnames";

import { Variants, Sizes } from "../Button/Button";
import styles from "../styles/Button.module.css";

interface Props extends LinkProps {
    children: React.ReactNode;
    size?: keyof typeof Sizes;
    variant?: keyof typeof Variants;
    target?: "_blank" | "_self" | "_parent" | "_top";
    title?: string;
    className?: string;
    rel?: string;
}

/**
 * Wrapper for using next/link and our button styles
 */
const ButtonLink = ({ children, size = "default", variant = "primary", href, title, target, className, ...props }: Props) => {
    const cn = clx(styles.button, Variants[variant], Sizes[size], className);

    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    return (
        <Link {...props} href={href} title={title} className={cn} target={target}>
            {children}
        </Link>
    );
};

export default ButtonLink;
